export const identity = (x) => x
